<template>
    <div>
            <div class="row my-3">

              <div class="col col-md-12">
                <div class="form-group required">
                  <label class='control-label'>Укажите причину, по которой хотите отказаться от оказания услуги</label>
                  <div><textarea class="form-control" id="time" v-model="comment" /></div>
                  <div class="invalid-msg" v-if="v$.comment.$error">Поле обязательно для заполнения</div>
                </div>
              </div>

            </div>

            <div>
              <div class="float-right d-flex align-items-center">
                <button-component class="btn btn-primary  btn-sm" v-on:click="save">Сохранить и отправить</button-component>
                <button-component type="button" kind="secondary" class="btn btn-default btn-sm mx-2" v-on:click="close">Отмена</button-component>
              </div>
             </div>

    </div>
</template>
<script>
import API from '../api/imar'
import Constants from '@/common/constants'
import { required } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import ButtonComponent from "../../../common/components/ButtonComponent";


export default {
  name: "RefuseWithComment",
  components: {ButtonComponent},
  props: {
    imarId:Number
  },
  created() {
  },
  mounted() {
  },
  emits: ['save', 'close'],
  data() {
    return {
        comment: null,
    };
  },
  methods: {
    save() {
        var self = this;

        self.v$.$touch();
        if (self.v$.$invalid) {
          Constants.alert.fire('Ошибка', 'Проверьте правильность заполнения полей', 'error' );
          return;
        }

        var data = {
            comment: this.comment,
            journalImarId: this.imarId
        };
        console.log(data);
        API.refuse(data).then(function (response) {
            Constants.alert.fire('Сохранение', response.data.message, response.data.success ? 'success' : 'error' );
            if(response.data.success) {
                self.$emit('save');
            }
        });
    },    
    close() {
      this.$emit('close');
    }
  },
  setup: () => ({ v$: useVuelidate() }),
  validations () {
    return {
        comment: { required },
    }
  }
}; 
</script>
<style lang="scss" scoped>
@import '/src/assets/theme/default/colors.scss';

.form-group.required .control-label:after { 
   content:"*";
   color:red;
}
.form-check.required .control-label:after { 
   content:"*";
   color:red;
}
.invalid-msg {
  color:red;
  font-size: 0.75rem;
}
</style>